module.exports = __webpack_public_path__ + "assets/img/unp.0fee9974.png";